module.exports = __webpack_public_path__ + "img/3D1.44b96362.png";